// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1AoTC","modalFooterButton":"ModalNotes_modalFooterButton__25rps"};